<template>
    <div :class="useOffset ? 'breadcrumb-with-offset' : 'breadcrumb-without-offset'" class="breadcrumb-container">
        <span class="breadcrumb-link" v-on:click="onClick">
            <slot>Tilbage</slot>
        </span>
    </div>
</template>

<script>
    import * as MutationTypes from '@/store/mutation-types'

    export default {
        name: 'breadcrumb',
        props: {
            to: {
                type: String,
                required: true
            },
            useOffset: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        methods: {
            onClick() {
                console.log('Breadcrumb click !');
                this.$store.commit(MutationTypes.SET_NAVIGATION_GUARD_ENABLED, false);

                this.$router.push(this.to)
            }
        }
    }
</script>
<style lang="less" scoped>
    @import "~@less/variables.less";

    .breadcrumb-container {
        &.breadcrumb-with-offset {
            position: relative;
            top: @breadcrumb-offset;
            margin-bottom: @breadcrumb-offset;
        }
    }

    .breadcrumb-link {
        cursor: pointer;
        padding-left: 0;

        color: #1C3637;
        font-size: @app-font-size-breadcrumb;

        &:before {
            content: "<";
            margin-right: 5px;
        }

        &:hover {
            text-decoration: none;
            color: lighten(#1C3637, 20%);
        }
    }
</style>